import script from "./toast.vue?vue&type=script&setup=true&lang=js"
export * from "./toast.vue?vue&type=script&setup=true&lang=js"

import "./toast.vue?vue&type=style&index=0&id=5930c84d&scoped=true&lang=postcss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5930c84d"]])

export default __exports__